<style scoped lang="scss">
.middle {
  margin-right: 1%;
  margin-left: 1%;
}
</style>
<template>
  <div class="container">
    <online-tabs></online-tabs>
    <div class="wrap mt15 flex">
      <div class="flex0 bg_fff pt15 pb15 width30">
        <online-filter type="2" @change="change"></online-filter>
        <online-list :list="list" @list-click="doOnlineAction"></online-list>
      </div>
      <div class="flex0 width40 bg_fff flex middle">
        <online-pat-info :info="currOrder" class="flex1" @btn-click="doOnlineAction"></online-pat-info>
      </div>
      <div class="flex0 width28 bg_fff">
        <online-videos :room-id="room.roomNo" ref="video"></online-videos>
      </div>

      <recipe-dialog ref="recipe"
                     type="online"
                     @handler="(name,type)=>{doOnlineAction(name,currOrder,type)}"
      ></recipe-dialog>
      <add-medical-record ref="addRecord"
                          v-if="currOrder"
                          :datas="currOrder"
      ></add-medical-record>
      <his-agree-dialog ref="agree"
                        :info="currOrder"
                        :list="unpaiedList"
                        @agree="doOnlineAction"
      ></his-agree-dialog>
      <plat-agree-dialog ref="platAgree"
                         type="renewal"
                         @handler="(name,type)=>{doOnlineAction(name, currOrder, type)}"
      ></plat-agree-dialog>
      <EPrescription ref="drawerRecipe"
                     source="Online"
                     :info="recipeInfo"
                     :orderDetail="currOrder"
      ></EPrescription>
      <Inspection ref="drawerInspection"
                  :inspectionType="inspectionType"
                  :orderDetail="currOrder"
      ></Inspection>
    </div>
  </div>
</template>

<script>
import OnlineTabs from "../components/online/tabs";
import OnlineFilter from "../components/online/filter";
import {OnlineMixin} from "../lib/mixins/online";
import OnlineList from "../components/online/list";
import OnlinePatInfo from "../components/online/pat-info";
import OnlineVideos from "../components/online/tencent-videos";
import {isEmpty, timeFormat} from "../lib/utils";
import {onlineService} from "../lib/service/online";
import {tee3getRoom} from "../lib/video/tee3";
import RecipeDialog from "../components/online/recipe-dialog";
import AddMedicalRecord from "../components/online/add-medical-record";
import EPrescription from "./prescription-management/EPrescription";
import {renewalService} from "../lib/service/renewal";
import HisAgreeDialog from "../components/renewal/dialog/hisAgree";
import PlatAgreeDialog from "../components/renewal/dialog/platAgree";
import {BOOKHOSID} from "../lib/config";
import Inspection from "./Inspection";

export default {
  name: "Online",
  data() {
    return {
      list: [],
      page: 1,
      roomInfo: {},
      currOrder: {},
      recipeInfo: {},
      inspectionType: '',
      unpaiedList: [],
    }
  },
  computed: {
    room() {
      return this.roomInfo.room || {};
    }
  },
  components: {
    Inspection,
    PlatAgreeDialog,
    HisAgreeDialog,
    EPrescription,
    AddMedicalRecord,
    RecipeDialog,
    OnlineVideos,
    OnlinePatInfo,
    OnlineList,
    OnlineFilter,
    OnlineTabs
  },
  mixins: [OnlineMixin],
  watch: {
    form: {
      handler() {
        this.getData();
      },
      deep: true
    }
  },
  methods: {
    change(data) {
      this.form = {...this.form, ...data};
    },
    doOnlineAction(name, order, type) {
      console.log('name', name, order);
      switch (name) {
        case '分诊':
        case '开住院单':
        case '加号':
        case '转诊':
          this.tip()
          break

      }
      const map = this.getOnlineActionMap();
      //如果order为空不作任何反应
      if (Object.keys(order).length === 0 && name !== '跳转到处方') return
      const action = [...map].find(([key]) => key === name);
      action[1](order, type);
    },
    getOnlineActionMap() {
      return new Map([
        ['接诊', async (order) => {
          this.$confirm('是否确认接诊患者？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(async () => {
            //this.$refs.video.enterRoom();
            this.roomInfo = await onlineService.intovideo(order.ddid);
            await this.intoVideo();
            await this.getInfo(order.ddid);
          }).catch(() => {

          });
        }],
        ['提醒进入诊间', async (order) => {
          if (await onlineService.sms(order.ddid)) this.$notify({
            title: '发送成功',
            message: '已经发送提醒短信',
            type: 'success'
          })
        }],
        ['查看资料', async (order) => {
          await this.getInfo(order.ddid);
        }],
        ['结束问诊', async order => {
          this.$confirm('是否结束问诊？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(async () => {
            if (await onlineService.complete(order.ddid)) {
              this.$notify({
                title: '结束问诊',
                message: '您已经结束问诊',
                type: 'success'
              });
              this.$refs.video.leaveRoom();
              this.currOrder = {}
            }
          }).catch(() => {
          });
        }],
        ['开处方', async order => {
          this.$refs.recipe.show()
          /* let room = tee3getRoom()
           if (!isEmpty(room)) {
               this.$message.error('离开当前页面前请先挂断视频！')
           } else {
               this.$refs.recipe.show()
           }*/
        }],
        ['his开方', async (order) => {
          this.currOrder = order;
          this.unpaiedList = await renewalService.unpaied({
            idcard: order.compatIdcard, hosId: BOOKHOSID
          })
          if (this.unpaiedList.length === 0) this.$message.error('HIS 处方记录为空');
          else this.$refs.agree.show();
        }],
        ['平台续方', async (order) => {
          this.$refs.platAgree.show();
        }],
        ['同意his处方', async (form) => {
          if (await renewalService.agree(
              form.bizId,
              'ONLINE_OUTPATIENT', //处方来源网络诊间
              form.orderNos,
              form.bookHosId,
              form.compatId)
          ) {
            this.$notify.success({
              title: '操作成功',
              message: '您已经同意申请续方'
            });
          }
        }],
        ['跳转到处方', async (order, type) => {
          console.log('【跳转到处方】', order, type)
          this.recipeInfo = {
            ddId: order.id,
            hosId: order.hosId,
            type: type,
            bizType: 'ONLINE_OUTPATIENT'
          }
          this.$refs.drawerRecipe.show()
          /*if (order && order.id) {
                 this.$router.push({
                     path: '/main/e-prescription',
                     query: {ddId: order.id, type: type, hosId: order.yyid, bizType: 'online'}
                 })
          }*/
        }],
        ['书写病历', async (order) => {
          console.log('order detail', order)
          let res = await this.checkAddedRecord(order.ddid)
          if (res) {
            this.$refs.addRecord.show()
          }
        }],
        ['开检查', async (order) => {
          console.log('order detail', order)
          this.inspectionType = 'CHECK'
          this.$refs.drawerInspection.show()
        }],
        ['开检验', async (order) => {
          this.inspectionType = 'INSPECT'
          this.$refs.drawerInspection.show()
        }],
      ]);
    },

    //判断是否书写过病历
    async checkAddedRecord(id) {
      let {obj} = await this.$http("smarthos.online.outpatient.medical.info", {id: id})
      if (obj && obj.createFlag === '0') {
        return true
      } else {
        this.$message.error('您已书写过病历！')
        return false
      }
    },

    async getInfo(id) {
      this.currOrder = await onlineService.info(id)
    },

    async intoVideo() {
      const {room} = this.roomInfo;
      console.log('runs here2', this.roomInfo)
      if (!isEmpty(room)) {
        console.log('runs here')
        this.$refs.video.enterRoom();
      }
    },

    async getData() {
      const {bookHosId, bookDocId, mzlb, bookDeptId} = this.form;
      this.list = [];
      if (!isEmpty(bookDocId) && !isEmpty(bookHosId)) {
        const date = timeFormat(Date.now(), '%Y-%m-%d');
        const {obj} = await onlineService.list({
          hosid: bookHosId,
          ysid: bookDocId,
          date,
          ksid: bookDeptId,
          orderType: mzlb === '2' ? '1' : undefined,
          // TODO 去掉日期，显示所有数据
          bdate: date,
          edate: date,
          pageSize: 10000
        });
        if (obj.code === '0') {
          this.list = obj.list;
        }
        /*const list = await onlineService.list2({
          hosid: bookHosId,
          ysid: bookDocId,
          date,
          orderType: mzlb === '2' ? '1' : undefined,
          bdate: date,
          edate: date,
          pageSize: 100001
        });
        this.list = list;*/
      }
    },
    tip() {
      this.$message.error('该功能暂未开放！')
    }
  },
}
</script>

